"use client";

import Link from "next/link";
import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type CTAActionVariant = "solid" | "outline";

interface CTAActionButtonProps {
  href: string;
  label: string;
  variant?: CTAActionVariant;
  size?: "sm" | "default" | "lg" | "xl";
  className?: string;
}

/**
 * Unified CTA button for "Demander un devis" / "S'inscrire" actions.
 * Uses solid or outline accent styles with text always white and no yellow hover.
 */
export function CTAActionButton({
  href,
  label,
  variant = "solid",
  size = "lg",
  className,
}: CTAActionButtonProps) {
  const buttonVariant: ButtonProps["variant"] = variant === "outline" ? "cta-outline" : "cta";

  return (
    <Button
      asChild
      size={size}
      variant={buttonVariant}
      className={cn(className)}
    >
      <Link href={href}>{label}</Link>
    </Button>
  );
}
